import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchFeed = createAsyncThunk('feed/fetch', async ({ page = 1 } = {}, { rejectWithValue }) => {
  try {
    const { data } = await api.get(`/feed?page=${page}&limit=15`);
    return { ...data, page };
  } catch (err) {
    return rejectWithValue(err.response?.data?.message);
  }
});

export const fetchTrending = createAsyncThunk('feed/trending', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/feed/trending');
    return data.posts;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message);
  }
});

export const createPost = createAsyncThunk('feed/create', async (formData, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/feed/posts', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data.post;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message);
  }
});

export const likePost = createAsyncThunk('feed/like', async (postId, { rejectWithValue }) => {
  try {
    const { data } = await api.post(`/feed/posts/${postId}/like`);
    return { postId, ...data };
  } catch (err) {
    return rejectWithValue(err.response?.data?.message);
  }
});

export const unlikePost = createAsyncThunk('feed/unlike', async (postId, { rejectWithValue }) => {
  try {
    const { data } = await api.delete(`/feed/posts/${postId}/like`);
    return { postId, ...data };
  } catch (err) {
    return rejectWithValue(err.response?.data?.message);
  }
});

const feedSlice = createSlice({
  name: 'feed',
  initialState: { posts: [], trending: [], total: 0, page: 1, hasMore: true, loading: false, error: null },
  reducers: {
    clearFeed(state) { state.posts = []; state.page = 1; state.hasMore = true; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeed.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchFeed.fulfilled, (state, action) => {
        state.loading = false;
        state.total = action.payload.total;
        state.page = action.payload.page;
        if (action.payload.page === 1) state.posts = action.payload.posts;
        else state.posts = [...state.posts, ...action.payload.posts];
        state.hasMore = state.posts.length < action.payload.total;
      })
      .addCase(fetchFeed.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchTrending.fulfilled, (state, action) => { state.trending = action.payload; })
      .addCase(createPost.fulfilled, (state, action) => { state.posts.unshift(action.payload); })
      .addCase(likePost.fulfilled, (state, action) => {
        const p = state.posts.find(p => p.id === action.payload.postId);
        if (p) { p.liked = true; p.likeCount = action.payload.likeCount; }
      })
      .addCase(unlikePost.fulfilled, (state, action) => {
        const p = state.posts.find(p => p.id === action.payload.postId);
        if (p) { p.liked = false; p.likeCount = action.payload.likeCount; }
      });
  }
});

export const { clearFeed } = feedSlice.actions;
export default feedSlice.reducer;
